import { render, staticRenderFns } from "./PhaseModuleCard.vue?vue&type=template&id=68c4b80e&scoped=true&"
import script from "./PhaseModuleCard.vue?vue&type=script&lang=js&"
export * from "./PhaseModuleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4b80e",
  null
  
)

export default component.exports